import { Modal } from "antd-mobile";
import React, { useContext, useEffect, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import PsContext from "../../context";
import { _ConfirmPay } from "../../models/pay";
import { groupByMultiple, momentDate, MuiConfirmWindow } from "../../utils";
import {
  Checkbox,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";

const OnlinyPayRequest = (props) => {
  const context = useContext(PsContext);

  const [loader, setLoader] = useState(false);
  const [validated, setValidated] = useState(false);
  const [showTerms, setShowTerms] = useState(false);

  const [response, setReponse] = useState([]);
  const [selectedList, setSelectedList] = useState([]);
  const [showNotAllow, setShowNotAllow] = useState(false);

  const [sourceList, setSourceList] = useState([]);
  const [showConfirm, setShowConfirm] = useState(false);

  useEffect(() => {
    if (props.dataSource) setSourceList(props.dataSource);
  }, []);

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      alert("Please accept terms and conditions & check the amount filled");
      return;
    }
    if (selectedList.length < 1) {
      alert("Select anyone category to pay");
      return;
    }

    setShowConfirm(true);
    /*Modal.confirm({
      title: "Do you want to pay ?",
      confirmText: "Yes, Pay Now",
      cancelText: "Cancel",
      onConfirm: () => confirmPayment(),
    });*/
  };

  const confirmPayment = () => {
    context.setLoader(true);
    _ConfirmPay({
      data: JSON.stringify(selectedList),
      college_uuid: context.user.college_uuid,
    }).then((res) => {
      if (res.status == "1") {
        setReponse(res.data);
      } else {
        Modal.show({
          title: "Error",
          content: res.message || "Unknown Error",
          closeOnMaskClick: true,
        });
        context.setLoader(false);
      }
    });
  };

  const itemsTotal = (items) => {
    let total = 0;
    items.map(
      (item) => (total = parseFloat(total) + parseFloat(item.fee_amount))
    );
    return parseFloat(total || 0).toFixed(2);
  };

  const getItemOptions = (item) => {
    return {
      student_uuid: item.student_uuid,
      cashbook_id: item.cashbook_id,
      semester: item.semester,
      college_year: item.college_year,
      fee_amount: item.fee_amount,
      original_amount: item.fee_amount,
      fee_category_id: item.fee_category_id,
      id: item.id,
      payment_gateway_id: item.payment_gateway_id,
      payment_gateway_subid: item.payment_gateway_subid,
      allow_part_payment: item.allow_part_payment,
    };
  };

  const handleSelect = (items) => {
    let d = [...selectedList];

    if (items.length > 0) {
      items.map((cat, i) => {
        let index = d.findIndex((item) => item.id == cat.id);
        if (index > -1) d.splice(index, 1);
        else d.push(getItemOptions(cat));
      });
    } else {
      let index = d.findIndex((item) => item.id == items.id);
      if (index > -1) d.splice(index, 1);
      else d.push(getItemOptions(items));
    }
    setSelectedList(d);
  };

  const checkItemSelected = (items, amountOnly = false) => {
    let rv = false;
    let d = [...selectedList];
    if (items.length > 0) {
      items.map((cat, i) => {
        let index = d.findIndex((item) => item.id == cat.id);
        if (index > -1) rv = true;
        else rv = false;
      });
    } else {
      let index = d.findIndex((item) => item.id == items.id);
      if (index > -1) rv = true;
      if (rv && amountOnly) return d[index]["fee_amount"];
    }
    return rv;
  };

  useEffect(() => {
    if (sourceList && sourceList.length > 0 && selectedList.length < 1) {
      let items = sourceList.filter(
        (item) =>
          item.allow_online_pay == "1" &&
          item.online_pay_type &&
          item.online_pay_type == "2"
      );

      setSelectedList(items);
    }
  }, [sourceList]);

  const listByCategoryGroup = () => {
    let items = sourceList.filter((item) => item.allow_online_pay == "1");
    let nullList = items.filter((item) => !item.fee_category_group_id);
    let notNullList = items.filter((item) => item.fee_category_group_id);
    let d = groupByMultiple(notNullList, function (obj) {
      return [obj.fee_category_group_id];
    });
    let rv = [];

    d.map((item, i) => {
      rv.push(
        <ListItem
          key={i}
          secondaryAction={<Typography>{itemsTotal(item)}</Typography>}
          disablePadding
        >
          <ListItemButton role={undefined} dense>
            <ListItemIcon>
              <Checkbox
                edge="start"
                checked={checkItemSelected(item)}
                tabIndex={-1}
                disableRipple
                onClick={(e) =>
                  item[0] &&
                  item[0].online_pay_type &&
                  item[0].online_pay_type == "1" &&
                  handleSelect(item)
                }
                inputProps={{ "aria-labelledby": i }}
              />
            </ListItemIcon>
            <ListItemText id={i} primary={item[0].fee_category_group_name} />
          </ListItemButton>
        </ListItem>
      );
      /*rv.push(
        <Row>
          <Col
            md={9}
            sm={9}
            xs={9}
            onClick={(e) =>
              item[0] &&
              item[0].online_pay_type &&
              item[0].online_pay_type == "1" &&
              handleSelect(item)
            }
          >
            <Form.Check
              type="checkbox"
              style={{ fontSize: "15px" }}
              checked={checkItemSelected(item)}
              label={item[0].fee_category_group_name}
            />
          </Col>
          <Col md={3} sm={3} xs={3} className="text-end">
            {itemsTotal(item)}
          </Col>
        </Row>
      );*/
    });

    nullList.map((item, i) => {
      if (item.fee_amount > 0) {
        rv.push(
          <>
            {i != 0 && <Divider />}
            <ListItem
              key={i}
              secondaryAction={
                item.allow_part_payment == "1" ? (
                  <>
                    <Form.Control
                      type="number"
                      size="sm"
                      min="1"
                      step="any"
                      className="text-end"
                      style={{ width: "150px", fontSize: "16px" }}
                      value={
                        checkItemSelected(item)
                          ? checkItemSelected(item, true)
                          : item.fee_amount
                      }
                      required={checkItemSelected(item) ? true : false}
                      onWheel={(e) => e.target.blur()}
                      onChange={(e) => handlePartEdit(item, e)}
                    />
                  </>
                ) : (
                  <Typography>{item.fee_amount}</Typography>
                )
              }
              disablePadding
            >
              <ListItemButton role={undefined} dense>
                <ListItemIcon>
                  <Checkbox
                    edge="start"
                    onClick={(e) =>
                      item.online_pay_type &&
                      item.online_pay_type == "1" &&
                      handleSelect(item)
                    }
                    checked={checkItemSelected(item)}
                    tabIndex={-1}
                    disableRipple
                    inputProps={{ "aria-labelledby": i }}
                  />
                </ListItemIcon>
                <ListItemText
                  id={i}
                  primary={
                    <>
                      {item.category_name}{" "}
                      {item.for_the_month &&
                        momentDate(item.for_the_month, "MMM-YYYY")}
                    </>
                  }
                />
              </ListItemButton>
            </ListItem>
          </>
        );
      }
    });
    return rv;
  };

  const handlePartEdit = (item, e) => {
    let v = e.target.value || 0;
    let s = [...selectedList];
    let index = s.findIndex((obj) => obj.id == item.id);
    if (index > -1) {
      let oamt = 0;
      if (!s[index].original_amount) {
        s[index]["original_amount"] = item.fee_amount;
        oamt = item.fee_amount;
      } else oamt = s[index].original_amount;

      // check part amount greater than original amount..
      if (parseFloat(v) >= parseFloat(oamt)) {
        e.target.value = oamt;
        return;
      } else {
        s[index]["fee_amount"] = e.target.value;
        setSelectedList(s);
      }
    }
  };

  const handleCancelClick = () => {
    if (props.onCancel) props.onCancel();
  };

  useEffect(() => {
    if (response && response.access_code)
      document.getElementById("redirect").submit();
  }, [response]);

  console.log("");

  return (
    <>
      {props.notAllowed.length > 0 && (
        <div className="mb-2 border-bottom pb-2">
          <h6 onClick={(e) => setShowNotAllow(!showNotAllow)}>
            The following payments cannot be made online
            <span className="ms-3">
              {!showNotAllow && <i className="fa-solid fa-angle-down"></i>}
              {showNotAllow && <i className="fa-solid fa-angle-up"></i>}
            </span>
          </h6>
          {showNotAllow && (
            <ul className="ms-0 ps-0">
              {props.notAllowed.map((item, i) => {
                return (
                  <li key={i}>
                    {item.category_name}
                    <span className="float-end">{item.fee_amount}</span>
                  </li>
                );
              })}
            </ul>
          )}
        </div>
      )}
      <Card>
        
        <Card.Body className="p-0">
          <Form noValidate validated={validated} onSubmit={handleFormSubmit}>
            {sourceList && sourceList.length > 0 && (
              <>
                <List>{listByCategoryGroup()}</List>
                <div className="px-3">
                  <Row>
                    <Col className="text-end fw-bold border-top pt-2">
                      <Typography>
                        Total : <b>{itemsTotal(selectedList)}</b>
                      </Typography>
                    </Col>
                  </Row>
                  <Row className="mt-2">
                    <Col md={12}>
                      <Form.Check
                        type="checkbox"
                        name="agree"
                        label={
                          <>
                            I agree to the{" "}
                            <a
                              className="text-primary"
                              onClick={(e) => setShowTerms(!showTerms)}
                            >
                              Terms and conditions
                            </a>
                          </>
                        }
                        required
                      />
                      {showTerms && (
                        <div>
                          <ul className="mx-0 px-0">
                            <li>
                              1. Our institution will not store any of your Bank
                              credentials / Card details, the system will
                              redirect you to concerned Bank pages only to
                              complete your transaction.
                            </li>
                            <li>
                              2. There is No refund(s) / No Cancellations / No
                              charge backs are allowed for the transactions done
                              through this channel.
                            </li>
                            <li>
                              3. In case of any dispute regarding the payments,
                              you are requested to contact institution
                              administrator.
                            </li>
                            <li>
                              4. Transaction fees charged would be borne by
                              cardholder for any payment
                            </li>
                            <li>
                              5. Transaction fees charged would not be refunded/
                              reversed for any refund or reversal and charge
                              back of any transaction.
                            </li>
                          </ul>
                        </div>
                      )}
                    </Col>
                  </Row>
                  <Row className="text-center mt-4">
                    <Col md={6} xs={6} sm={6}>
                      <Button
                        type="button"
                        variant="danger"
                        className="mx-1 w-100"
                        onClick={(e) => handleCancelClick()}
                      >
                        <i className="fa-solid fa-xmark me-2"></i>Cancel
                      </Button>
                    </Col>
                    <Col md={6} xs={6} sm={6}>
                      <Button
                        type="submit"
                        variant="success"
                        className="mx-1 w-100"
                        disabled={selectedList.length < 1}
                      >
                        <i className="fa-solid fa-check me-2"></i>Pay Now
                      </Button>
                    </Col>
                  </Row>
                </div>
              </>
            )}
          </Form>
        </Card.Body>
      </Card>
      {response && response.access_code && (
        <form
          method="post"
          name="redirect"
          id="redirect"
          action="https://secure.ccavenue.com/transaction/transaction.do?command=initiateTransaction"
        >
          <input type="hidden" name="encRequest" value={response.reqdata} />
          <input
            type="hidden"
            name="access_code"
            value={response.access_code}
          />
        </form>
      )}

      <MuiConfirmWindow
        open={showConfirm}
        title="Confirm"
        onClose={(e) => setShowConfirm(false)}
        cancelText="Cancel"
        okText="Yes, Pay Now"
        onSuccess={(e) => confirmPayment()}
      >
        Do you want to make Payment ?
      </MuiConfirmWindow>
    </>
  );
};
export default OnlinyPayRequest;
